import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsEye } from "react-icons/bs";
import { FiImage, FiSun, FiHome, FiMonitor } from "react-icons/fi";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { supabase } from '../supabaseClient';
import SEOHelmet, {
  siteUrl,
  gallerySchema,
  buildBreadcrumb,
} from "../components/SEOHelmet";

const AOS_VARIANTS = ['fade-left', 'fade-right', 'fade-up', 'fade-down'];

const Gallery = () => {
  const [photos, setPhotos]   = useState([]);
  const [error, setError]     = useState('');
  const [category, setCategory] = useState('All');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    Fancybox.bind("[data-fancybox]", {
      Toolbar: true,
      buttons: ["slideShow", "thumbs", "zoom", "fullscreen", "close"],
    });

    const fetchPhotos = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('photos')
          .select('*')
          .order('created_at', { ascending: false });

        if (error) throw error;

        const mapped = data.map((row, i) => ({
          src:    row.image_url,
          width:  800,
          height: 600,
          key:    String(row.id),
          aos:    AOS_VARIANTS[i % AOS_VARIANTS.length],
          category: row.category || 'Newborn',
        }));
        setPhotos(mapped);
      } catch (err) {
        setError('Could not load gallery images.');
      } finally {
        setLoading(false);
      }
    };

    fetchPhotos();
  }, []);

  return (
    <>
      
      <SEOHelmet
        title="Baby Photography Gallery | Newborn, Cake Smash & Milestone Photos – Hyderabad"
        description="Browse Baby Twinkles Photography's stunning gallery of newborn, baby milestone, cake smash, maternity & family portraits taken in Hyderabad. See why we are Hyderabad's most-loved baby photography studio!"
        keywords="baby photography gallery Hyderabad, newborn photos Hyderabad, cake smash photos Hyderabad, baby milestone photos Hyderabad, maternity photography gallery Hyderabad, family portrait gallery Hyderabad, baby photoshoot examples Hyderabad, best baby photos Hyderabad, newborn photography portfolio Hyderabad"
        canonicalUrl={`${siteUrl}/gallery`}
        ogType="website"
        schema={[
          gallerySchema,
          buildBreadcrumb([
            { name: "Home", url: `${siteUrl}/` },
            { name: "Gallery", url: `${siteUrl}/gallery` },
          ]),
        ]}
      />
      <div className="inner-page-banner" data-aos="fade-down">
        <div className="banner-wrapper">
          <div className="container-fluid">
            <div className="banner-main-content-wrap">
              <div className="row">
                <div className="col-12">
                  <div className="banner-content" data-aos="fade-up">
                    <ul className="breadcrumb-list mt-5 pt-5 d-flex justify-content-center align-items-center">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>Gallery</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-4" data-aos="fade-up" style={{ overflowX: "hidden" }}>
        {error && (
          <div style={{ textAlign: 'center', color: '#ef4444', padding: '40px 0' }}>
            {error}
          </div>
        )}
        {photos.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 30, gap: 8, flexWrap: 'wrap' }}>
          <button
            onClick={() => {
              setCategory('All');
              setLoading(true);
              setTimeout(() => setLoading(false), 500);
            }}
            style={{
              padding: '6px 12px',
              borderRadius: 6,
              border: category === 'All' ? '2px solid #efb93f' : '1px solid #333',
              background: category === 'All' ? '#efb93f' : '#000',
              color: '#fff',
              fontSize: 12,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              fontWeight: category === 'All' ? 600 : 400,
              flex: '1 1 auto',
              minWidth: '70px',
              justifyContent: 'center'
            }}
          >
            <FiImage size={14} /> All
          </button>
          {/* <button
            onClick={() => {
              setCategory('Newborn');
              setLoading(true);
              setTimeout(() => setLoading(false), 500);
            }}
            style={{
              padding: '6px 12px',
              borderRadius: 6,
              border: category === 'Newborn' ? '2px solid #efb93f' : '1px solid #333',
              background: category === 'Newborn' ? '#efb93f' : '#000',
              color: '#fff',
              fontSize: 12,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              fontWeight: category === 'Newborn' ? 600 : 400,
              flex: '1 1 auto',
              minWidth: '70px',
              justifyContent: 'center'
            }}
          >
            <FiSun size={14} /> Newborn
          </button> */}
          <button
            onClick={() => {
              setCategory('Indoor');
              setLoading(true);
              setTimeout(() => setLoading(false), 500);
            }}
            style={{
              padding: '6px 12px',
              borderRadius: 6,
              border: category === 'Indoor' ? '2px solid #efb93f' : '1px solid #333',
              background: category === 'Indoor' ? '#efb93f' : '#000',
              color: '#fff',
              fontSize: 12,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              fontWeight: category === 'Indoor' ? 600 : 400,
              flex: '1 1 auto',
              minWidth: '70px',
              justifyContent: 'center'
            }}
          >
            <FiHome size={14} /> Indoor
          </button>
          <button
            onClick={() => {
              setCategory('Outdoor');
              setLoading(true);
              setTimeout(() => setLoading(false), 500);
            }}
            style={{
              padding: '6px 12px',
              borderRadius: 6,
              border: category === 'Outdoor' ? '2px solid #efb93f' : '1px solid #333',
              background: category === 'Outdoor' ? '#efb93f' : '#000',
              color: '#fff',
              fontSize: 12,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              fontWeight: category === 'Outdoor' ? 600 : 400,
              flex: '1 1 auto',
              minWidth: '70px',
              justifyContent: 'center'
            }}
          >
            <FiMonitor size={14} /> Outdoor
          </button>
        </div>
        )}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{
              width: 40,
              height: 40,
              border: '3px solid #f3f3f3',
              borderTop: '3px solid #efb93f',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 16px'
            }}></div>
            <p style={{ color: '#666', margin: 0 }}>Loading photos...</p>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        ) : photos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <FiImage size={48} style={{ opacity: 0.3, marginBottom: 12 }} />
            <p style={{ color: '#666', margin: 0 }}>No photos available</p>
          </div>
        ) : (
          <>
            <style>{`
              @media (max-width: 768px) {
                .gallery-img {
                  height: 150px !important;
                }
              }
            `}</style>
            <div className="row g-3">
            {photos.filter(photo => category === 'All' || photo.category === category).map((photo) => (
              <div 
                key={photo.key} 
                className="col-lg-3 col-md-3 col-6"
              >
                <div
                  style={{
                    position: 'relative',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    cursor: 'pointer'
                  }}
                >
                  <a
                    href={photo.src}
                    data-fancybox="gallery"
                  >
                    <img
                      src={photo.src}
                      alt="image"
                      style={{
                        width: '100%',
                        height: '180px',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                      className="border rounded gallery-img"
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
          </>
        )}
      </div>
    </>
  );
};

export default Gallery;
